module.exports = __webpack_public_path__ + "img/undraw_ai-code-generation_imyw.52e6e3ba.svg";